import React, { Component }  from 'react'

import { BundleContainer, PayloadContainer } from 'components/bundle/containers'

import BundleHeader from './BundleHeader'
import BundleBody from './BundleBody'

class DemoWorkshop extends Component {
	render() {
		return (
			<BundleContainer>
				<BundleHeader />
				<PayloadContainer>
					<BundleBody />
				</PayloadContainer>
			</BundleContainer>
		);
	}
}

export default DemoWorkshop;



// WEBPACK FOOTER //
// ./src/components/bundle/v1/Bundle.jsx